import { render } from "./qgPollutionSourcesMonitor.vue?vue&type=template&id=3247a3ce&scoped=true"
import script from "./qgPollutionSourcesMonitor.vue?vue&type=script&lang=js"
export * from "./qgPollutionSourcesMonitor.vue?vue&type=script&lang=js"

import "./qgPollutionSourcesMonitor.vue?vue&type=style&index=0&id=3247a3ce&lang=scss"
import "./qgPollutionSourcesMonitor.vue?vue&type=style&index=1&id=3247a3ce&scoped=true&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3247a3ce"]])

export default __exports__